<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5">
    <loading v-if="loadingState" />
    <div class="container whiteCont mt-5 mb-5">

			<div class="row justify-content-center verticalCentred">

				<div class="col-6 mt-5 pt-5">
					<h1 class="mb-5 center" v-model="result" type="text">{{result}}</h1>
					<div v-if="status" class="mt-5 center">
					<router-link class="btn btn-primary btn-lg" to="/login">Accedi</router-link>
				</div>

				</div>
			</div>

		</div>

	</div>
</template>


<script>
  import axios from 'axios'
  export default {
	name: 'confirm',
	components: {
		},
	data () {

      return {
        result: 'Verifica Token',
		      status: false,
		        loadingState: false
      }
    },
    methods: {
      confirm: function () {
        console.log( this.$route )
        const token = this.$route.query.token
        var _vue = this
        console.log( token )

        localStorage.setItem('user-token', token)
          _vue.$router.push('/')
        setTimeout( function(){
          window.location.reload()
        },1000 )



      }
    },
	mounted(){
		this.confirm()
	},

  }

</script>



// WEBPACK FOOTER //
// src/components/loginasgod/index.vue